<div class="scad-sidebar">
  <div class="scad-sidebar__head">
    <div>Tools</div>
    <div><img src="/assets/images/svg/click-side.svg" alt="" /></div>
  </div>

  <div class="pt-4 pb-4">
    <div class="scad-input scad-input--search-right">
      <div class="scad-input__search-icon">
        <em class="scad-icon scad-icon-Search"></em>
      </div>
      <input type="text" class="scad-input scad-input--search-right" placeholder="Search.."/>
    </div>
  </div>

  <div class="scad-sidebar__main-menu">
    <ul class="scad-sidebar__side-menu">

      <li class="scad-sidebar__side-item" *ngFor="let item of _flowBuilder.sidebar_data; let outerIndex = index" >
        <a class="scad-sidebar__item" id="{{outerIndex}}">

          <img src="{{item.icon}}" alt="" />
          <label for="{{outerIndex}}">{{item.name}}
            <span class="scad-sidebar__arrow-action"> -</span>
          </label>
        </a>
        <ul class="scad-sidebar__sub-side-menu">
          <div class="scad-sidebar__sub-side-item" *ngFor="let subItem of item.submenu;let innerIndex = index"
         >
            <a class="scad-sidebar__sub-item"  draggable="true" [id]="subItem?.name" (dragstart)="onDragStart($event,outerIndex,innerIndex)">
              <img class="sub-icon" src="{{subItem.icon}}" alt="" />
              <span>{{subItem.name}}</span>
            </a>
          </div>
        </ul>
      </li>
    </ul>
  </div>
</div>

<!-- (click)="getPreviewNode()" -->

